/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Coaching_Unread_BadgeInputs */

const en_us2_coaching_unread_badge = /** @type {(inputs: Coaching_Unread_BadgeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`New: ${i?.count}`)
};

const pt_br2_coaching_unread_badge = /** @type {(inputs: Coaching_Unread_BadgeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Novas: ${i?.count}`)
};

const pt_pt2_coaching_unread_badge = /** @type {(inputs: Coaching_Unread_BadgeInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Novas: ${i?.count}`)
};

/** @type {(inputs: Coaching_Unread_BadgeInputs) => LocalizedString} */
const es_419_coaching_unread_badge = en_us2_coaching_unread_badge;

/** @type {(inputs: Coaching_Unread_BadgeInputs) => LocalizedString} */
const fr_fr2_coaching_unread_badge = en_us2_coaching_unread_badge;

/** @type {(inputs: Coaching_Unread_BadgeInputs) => LocalizedString} */
const de_de2_coaching_unread_badge = en_us2_coaching_unread_badge;

/** @type {(inputs: Coaching_Unread_BadgeInputs) => LocalizedString} */
const it_it2_coaching_unread_badge = en_us2_coaching_unread_badge;

/**
* | output |
* | --- |
* | "New: {count}" |
*
* @param {Coaching_Unread_BadgeInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const coaching_unread_badge = /** @type {((inputs: Coaching_Unread_BadgeInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coaching_Unread_BadgeInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_coaching_unread_badge(inputs)
	if (locale === "es-419") return es_419_coaching_unread_badge(inputs)
	if (locale === "pt-PT") return pt_pt2_coaching_unread_badge(inputs)
	if (locale === "fr-FR") return fr_fr2_coaching_unread_badge(inputs)
	if (locale === "de-DE") return de_de2_coaching_unread_badge(inputs)
	if (locale === "it-IT") return it_it2_coaching_unread_badge(inputs)
	return en_us2_coaching_unread_badge(inputs)
});
export { coaching_unread_badge as "coaching.unread_badge" }